import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AlertTriangle, ArrowLeft, Mail } from 'lucide-react';
import Card from '../ui/Card';
import Button from '../ui/Button';

const PaymentError = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason');

  const getErrorMessage = () => {
    switch (reason) {
      case 'missing_order_id':
        return 'No order ID was provided. This may be a malformed payment link.';
      case 'order_not_found':
        return 'The order could not be found in our system.';
      case 'server_error':
        return 'A server error occurred while processing your payment callback.';
      default:
        return 'An unexpected error occurred during payment processing.';
    }
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 'calc(100vh - 48px)',
      padding: '20px'
    }}>
      <Card style={{
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center',
        padding: '40px 30px'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          backgroundColor: 'var(--color-warning-bg-strong)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px'
        }}>
          <AlertTriangle size={48} color="#f59e0b" />
        </div>

        <h1 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: 'var(--color-text-primary)',
          margin: '0 0 12px 0'
        }}>
          Payment Error
        </h1>

        <p style={{
          fontSize: '16px',
          color: 'var(--color-text-muted)',
          margin: '0 0 32px 0',
          lineHeight: '1.5'
        }}>
          {getErrorMessage()}
        </p>

        {reason && (
          <div style={{
            padding: '12px 16px',
            backgroundColor: 'var(--color-warning-bg-strong)',
            borderRadius: '8px',
            marginBottom: '32px',
            border: '1px solid var(--color-warning-border)'
          }}>
            <p style={{
              fontSize: '12px',
              color: 'var(--color-warning-fg)',
              margin: '0 0 4px 0'
            }}>
              Error Code
            </p>
            <p style={{
              fontSize: '14px',
              fontWeight: '600',
              color: '#78350f',
              margin: 0,
              fontFamily: 'monospace',
              textTransform: 'uppercase'
            }}>
              {reason}
            </p>
          </div>
        )}

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px'
        }}>
          <Button
            onClick={() => navigate('/dashboard')}
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              backgroundColor: 'var(--color-accent)',
              color: 'white'
            }}
          >
            <ArrowLeft size={18} />
            Back to Dashboard
          </Button>
        </div>

        <div style={{
          marginTop: '24px',
          padding: '16px',
          backgroundColor: 'var(--color-danger-bg)',
          borderRadius: '8px',
          border: '1px solid var(--color-danger-border)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            marginBottom: '8px'
          }}>
            <Mail size={16} color="#dc2626" />
            <p style={{
              fontSize: '14px',
              fontWeight: '600',
              color: 'var(--color-danger-hover)',
              margin: 0
            }}>
              Need Help?
            </p>
          </div>
          <p style={{
            fontSize: '12px',
            color: 'var(--color-danger-fg)',
            margin: 0,
            lineHeight: '1.5'
          }}>
            If you were charged but encountered this error, please contact our support team immediately with the error code above.
          </p>
        </div>
      </Card>
    </div>
  );
};

export default PaymentError;
